import { schemaUtility } from 'utility';

import { NextCalculatedDto, nextCalculatedDtoSchema } from './contracts';
import { toInternalHourDomain } from './transformers';
type MockedJsonFile =
  | 'AggregatedInternalBucketResolution.json'
  | 'BaseAggregatedInternalBucketResolution.json';

const loadJson = async (file: MockedJsonFile) => {
  const res = await fetch(`/mocked/${file}`);
  return await res.json();
};

async function getAggregatedInternalBucketResolution(args: {
  companyId: string;
  bearerToken: string;
  resolution: 'SubZone' | 'Zone' | 'Employee';
  bucketResolution: 'Hour';
  dates: Time.Date[];
}) {
  const data = await loadJson('AggregatedInternalBucketResolution.json');

  return new Promise<NormalizedDomain<Data.InternalHour>>((resolve) => {
    setTimeout(() => {
      const parsed = schemaUtility
        .apiResponse(schemaUtility.array(nextCalculatedDtoSchema))
        .safeParse(data);

      if (!parsed.success) {
        alert('parsing failed in fetchCountryDomain');
        throw parsed.error;
      }

      const dtos: NextCalculatedDto[] = parsed.data.data ?? [];

      const { internalHourDomain } = toInternalHourDomain({ dtos });

      resolve(internalHourDomain);
    }, 300);
  });
}

export { getAggregatedInternalBucketResolution };
